import { SetState } from 'zustand';
import { ValueState } from '@ui5/webcomponents-react';
import { CommonDitaQueryState } from 'stores/interfaces/CommonQueryState';

export const commonDitaQueryInitialStateFields = {
  xtmProjectName: undefined,
  fileTitle: '',
  fileName: '',
  loio: '',
  deliverable: '',
  cmsProject: '',
  sourceContact: '',
  submap: undefined
};
export const commonDitaQueryInitialStateValueStates = {
  fileTitleValueState: ValueState.None,
  fileNameValueState: ValueState.None,
  loioValueState: ValueState.None,
  deliverableValueState: ValueState.None,
  cmsProjectValueState: ValueState.None,
  sourceContactValueState: ValueState.None
};
export const commonDitaQueryInitialState = {
  ...commonDitaQueryInitialStateFields,
  ...commonDitaQueryInitialStateValueStates,
  fetching: false
};

export const createCommonDitaQuerySlice = <T extends CommonDitaQueryState>(set: SetState<T>) => ({
  ...commonDitaQueryInitialState,
  setXtmProjectName: (value: string) => set(() => ({ xtmProjectName: value })),
  setFileTitle: (value: string) => set(() => ({ fileTitle: value })),
  setFileTitleValueState: (value: ValueState) => set(() => ({ fileTitleValueState: value })),
  setFileName: (value: string) => set(() => ({ fileName: value })),
  setFileNameValueState: (value: ValueState) =>
    set(() => ({
      fileNameValueState: value
    })),
  setLoio: (value: string) => set(() => ({ loio: value })),
  setLoioValueState: (value: ValueState) => set(() => ({ loioValueState: value })),
  setDeliverable: (value: string) => set(() => ({ deliverable: value })),
  setDeliverableValueState: (value: ValueState) =>
    set(() => ({
      deliverableValueState: value
    })),
  setCmsProject: (value: string) => set(() => ({ cmsProject: value })),
  setCmsProjectValueState: (value: ValueState) =>
    set(() => ({
      cmsProjectValueState: value
    })),
  setSourceContact: (value: string) => set(() => ({ sourceContact: value })),
  setSourceContactValueState: (value: ValueState) =>
    set(() => ({
      sourceContactValueState: value
    })),
  setSubmap: (value: string) => set(() => ({ submap: value })),
  setLanguagesTranslatorTeams: (value?: string) => set(() => ({ languagesTranslatorTeams: value })),
  setFetching: (value: boolean) => set(() => ({ fetching: value })),
  resetData: () =>
    set({
      fileTitle: '',
      fileTitleValueState: ValueState.None,
      fileName: '',
      fileNameValueState: ValueState.None,
      loio: '',
      loioValueState: ValueState.None,
      deliverable: '',
      deliverableValueState: ValueState.None,
      cmsProject: '',
      cmsProjectValueState: ValueState.None,
      xtmProjectName: '',
      sourceContact: '',
      sourceContactValueState: ValueState.None,
      submap: ''
    })
});
